export enum NavigationPath {
  Home = '',
  UploadSpace = '/espace-de-depot',
  UploadsHistory = '/historique-des-depots',
  TrackingTable = '/tableau-de-suivi',
  Archives = '/archives',
  LogsTable = '/tableau-de-logs',
  NotificationsCenter = '/centre-de-notifications',
  Logout = '/logout',
  UnAuthorised = '/unauthorised',
}
